import { Button } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { LotteryName } from '../../../../lottery-purchases/types';
import { getLotteryResultsHref } from '../../../utils';

type ResultsSectionLiveDrawLinkProps = {
  lottery: LotteryName;
  className?: string;
};

/**
 * Small secondary CTA linking to the results page for live-draw lotteries.
 * Intended to sit beside the “Latest results” heading (see ResultsSectionTitle children).
 * Hides winning numbers on tippengine so players can watch the live-draw replay first.
 * Namespace: 'lotteries.results.mini'. Key: 'view_all'.
 */
function ResultsSectionLiveDrawLink({ lottery, className }: ResultsSectionLiveDrawLinkProps) {
  const t = useTranslations('lotteries.results.mini');
  const href = getLotteryResultsHref(lottery);

  if (!href) return null;

  return (
    <Button asChild variant="secondary" size="s" className={className} data-track-name="View All">
      <Link href={href} data-testid="view-results-link">
        {t('view_all')}
      </Link>
    </Button>
  );
}

export { ResultsSectionLiveDrawLink };
export type { ResultsSectionLiveDrawLinkProps };
